var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeocoderMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 65,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-122.7%",
    y: "-71.9%",
    width: "345.5%",
    height: "270.3%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.17254902 0 0 0 0 0.188235294 0 0 0 0 0.196078431 0 0 0 0.2 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 4c6.081 0 11 5.008 11 11.2C31 23.6 20 36 20 36S9 23.6 9 15.2C9 9.008 13.919 4 20 4zm0 8a3 3 0 100 6 3 3 0 000-6z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 9)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M20 3.5c3.18 0 6.056 1.309 8.137 3.428A11.766 11.766 0 0131.5 15.2c0 8.522-11.126 21.132-11.126 21.132s-.13.148-.374.413c-.244-.265-.374-.413-.374-.413S8.5 23.722 8.5 15.2c0-3.233 1.285-6.157 3.363-8.272A11.366 11.366 0 0120 3.5zm0 9c-.69 0-1.315.28-1.768.732A2.492 2.492 0 0017.5 15c0 .69.28 1.315.732 1.768A2.492 2.492 0 0020 17.5c.69 0 1.315-.28 1.768-.732A2.492 2.492 0 0022.5 15c0-.69-.28-1.315-.732-1.768A2.492 2.492 0 0020 12.5z",
    fill: "#012C5A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeocoderMarker);
export default __webpack_public_path__ + "static/media/geocoder-marker.c1c39046cdacb0604f1d926548c923c7.svg";
export { ForwardRef as ReactComponent };